import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import InfiniteScroll from 'react-infinite-scroll-component';

import LoadingSpinner from 'components/common/loaders/LoadingSpinner';
import { SurveyTemplate } from 'types/survey_template.types';

interface TemplateListProps {
  templates: SurveyTemplate[];
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
  onSelectTemplate: (template: SurveyTemplate) => void;
  onFetchNextPage: () => void;
}

export const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  hasNextPage,
  isFetchingNextPage,
  onSelectTemplate,
  onFetchNextPage
}) => (
  <InfiniteScroll
    dataLength={templates.length}
    next={onFetchNextPage}
    hasMore={hasNextPage ?? false}
    loader={isFetchingNextPage && <LoadingSpinner />}
    scrollableTarget="template-list-container"
    className="tw-flex tw-h-full tw-flex-col"
  >
    <div className="tw-pr-2">
      {templates.map((template, index) => (
        <div
          key={template.id}
          onClick={() => onSelectTemplate(template)}
          className={`tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-border-0
            tw-border-b tw-border-solid tw-border-border-grey tw-pb-4 tw-transition-colors
            ${index === 0 ? 'tw-mt-0' : 'tw-mt-4'}`}
        >
          <div>
            <p className="tw-mb-0.5 tw-text-left tw-text-sm tw-font-normal tw-leading-5 tw-text-dark-black">
              {template.title}
            </p>
            {template.description && (
              <p className="tw-mb-0 tw-text-left tw-text-sm tw-font-normal tw-leading-5 tw-text-primary-grey">
                {template.description}
              </p>
            )}
          </div>
          <div className="tw-flex tw-items-center tw-justify-center">
            <ChevronRightIcon className="tw-h-5 tw-w-5 tw-text-muted-foreground" />
          </div>
        </div>
      ))}
    </div>
  </InfiniteScroll>
);
